import { apiCall } from "../configs/axiosConfigs";

/**
 * Creador genérico para fetchers compatibles con InfiniteLoader.
 * Funciona tanto con POST (por defecto) como con GET.
 */
export function makePageFetcher({
  url,
  method = "POST",
  staticPayload = {},
  pageField = "pageNumber",
  limitField = "pageSize",
  dataPath = "data", // propiedad del array dentro de la respuesta
  totalPath = "totalRecords", // propiedad del total
  filtersKey = "filters", // nombre de la variable para los filtros
  serializeFiltersAsJson = true, // Si true, envía filters como JSON string en GET; si false, usa serialización de axios (filters[key]=value)
}) {
  return async ({ page, pageSize, signal }) => {
    // Separar filtros del resto del staticPayload
    const hasFilters = staticPayload && Object.keys(staticPayload).length > 0;
    const filters = hasFilters ? staticPayload : undefined;

    const payload =
      method === "GET"
        ? null
        : {
            [pageField]: page,
            [limitField]: pageSize,
            ...(filters ? { [filtersKey]: filters } : {}),
          };

    // Para GET, enviar filtros en el objeto "filters"
    // Opción 1: Como JSON string (el backend necesita hacer JSON.parse)
    // Opción 2: Como objeto anidado (axios serializa como filters[idCategoria]=123)
    const params =
      method === "GET"
        ? {
            [pageField]: page,
            [limitField]: pageSize,
            ...(filters
              ? serializeFiltersAsJson
                ? { [filtersKey]: JSON.stringify(filters) }
                : { [filtersKey]: filters } // axios serializa automáticamente como objeto anidado
              : {}),
          }
        : undefined;

    const res = await apiCall({
      url,
      method,
      data: payload,
      params,
      signal,
    });

    const data = res.data || res;

    const items =
      data[dataPath] ||
      data.items ||
      data.results ||
      data.data ||
      [];

    const total = data[totalPath] || data.total || 0;

    return {
      items,
      total,
      hasMore: page * pageSize < total,
      page,
    };
  };
}
